module.exports = __webpack_public_path__ + "static/media/country1.7e8114da.mp3";